module.exports = __webpack_public_path__ + "assets/img/select_products3.3b099706.svg";